/**
 * Wishlist functionality
 */
class Wishlist {
  constructor() {
    this.storageKey = 'guest_wishlist';
    this.wishlist = [];
    this.isCustomerLoggedIn = !!window.customerId;
    
    this.init();
  }

  init() {
    // 1. Read guest wishlist from localStorage
    const guestWishlist = this.getGuestWishlist();

    // 2. If logged in, merge and save
    if (this.isCustomerLoggedIn) {
      const customerWishlist = window.customerWishlist || [];
      
      // Merge lists avoiding duplicates
      const mergedWishlist = [...new Set([...guestWishlist, ...customerWishlist])];
      
      this.wishlist = mergedWishlist;

      if (guestWishlist.length > 0) {
        // Save the merged list to customer's metafield
        this.saveWishlistToMetafield(mergedWishlist);
        
        // Clear localStorage as requested
        localStorage.removeItem(this.storageKey);
      }
    } else {
      this.wishlist = guestWishlist;
    }

    this.updateIcons();
    this.bindEvents();
    
    // If on wishlist page, render items
    if (document.querySelector('#wishlist-container')) {
      this.renderWishlistPage();
    }
  }

  getGuestWishlist() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch (e) {
      return [];
    }
  }

  saveGuestWishlist(list) {
    localStorage.setItem(this.storageKey, JSON.stringify(list));
  }

  saveWishlistToMetafield(list) {
    // Placeholder for actual App Proxy or Custom Endpoint to save metafield
    console.log('Saving wishlist to metafield:', list);
    
    // Example fetch request to a typical app proxy
    /*
    fetch('/apps/wishlist/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerId: window.customerId,
        wishlist: list
      })
    }).then(res => res.json()).then(data => {
      console.log('Metafield updated successfully', data);
    }).catch(err => {
      console.error('Error updating metafield:', err);
    });
    */
  }

  toggle(handle) {
    const index = this.wishlist.indexOf(handle);
    if (index === -1) {
      this.wishlist.push(handle);
    } else {
      this.wishlist.splice(index, 1);
    }

    if (this.isCustomerLoggedIn) {
      this.saveWishlistToMetafield(this.wishlist);
    } else {
      this.saveGuestWishlist(this.wishlist);
    }

    this.updateIcons();
    
    // Re-render if on wishlist page
    if (document.querySelector('#wishlist-container')) {
      this.renderWishlistPage();
    }
  }

  updateIcons() {
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (this.wishlist.includes(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });

    const bubble = document.getElementById('wishlist-icon-bubble');
    const countElement = document.getElementById('wishlist-count');
    if (bubble && countElement) {
      const count = this.wishlist.length;
      if (count > 0) {
        countElement.innerText = count;
        bubble.style.display = 'block';
      } else {
        bubble.style.display = 'none';
      }
    }
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.wishlist-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.getAttribute('data-product-handle');
        if (handle) {
          this.toggle(handle);
        }
      }
    });
  }

  async renderWishlistPage() {
    const container = document.querySelector('#wishlist-container');
    if (!container) return;

    if (this.wishlist.length === 0) {
      container.innerHTML = '<p class="text-center">Your wishlist is empty.</p>';
      return;
    }

    container.innerHTML = '<div class="flex justify-center py-8"><div class="loading-spinner"></div></div>';

    try {
      // Fetch exact product card HTML using Section Rendering API
      const productPromises = this.wishlist.map(handle => 
        fetch(`/products/${handle}?section_id=custom-product-card-renderer`)
          .then(res => {
            if (!res.ok) return null;
            return res.text();
          })
          .catch(() => null)
      );
      
      const results = await Promise.all(productPromises);
      const productsHTML = results.filter(html => html !== null);

      if (productsHTML && productsHTML.length > 0) {
        let html = '<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-theme">';
        
        productsHTML.forEach(productHtml => {
          // Parse HTML and extract inner card to avoid wrapping section div
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = productHtml;
          
          // Fix lazy loaded images since they won't trigger automatically
          tempDiv.querySelectorAll('img, source').forEach(el => {
            if (el.hasAttribute('data-src')) {
              el.setAttribute('src', el.getAttribute('data-src'));
              el.removeAttribute('data-src');
            }
            if (el.hasAttribute('data-srcset')) {
              el.setAttribute('srcset', el.getAttribute('data-srcset'));
              el.removeAttribute('data-srcset');
            }
            el.classList.remove('no-js-hidden');
          });

          const card = tempDiv.querySelector('.card--product') || tempDiv.firstElementChild;
          if (card) {
            const wishlistBtn = card.querySelector('.wishlist-btn');
            if (wishlistBtn) {
              wishlistBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
            }
            html += `<div>${card.outerHTML}</div>`;
          }
        });
        html += '</div>';
        container.innerHTML = html;
        
        // Ensure wishlist active states are refreshed for the newly injected cards
        this.updateIcons();
      } else {
        container.innerHTML = '<p class="text-center">Your wishlist is empty.</p>';
      }
    } catch (err) {
      console.error('Error fetching wishlist products:', err);
      container.innerHTML = '<p class="text-center text-error">Failed to load wishlist products.</p>';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.WishlistApp = new Wishlist();
});
